import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// PLAN APIS
// ================================

// 🔹 PLAN LIST
export async function getPlanList(plan_status = "", plan_user_type = "", page = "0") {
  try {
    const fd = new FormData();
    fd.append("plan_status", plan_status);
    fd.append("plan_user_type", plan_user_type);
    fd.append("page", page);

    const response = await axios.post(`${apiBaseUrl}planapis/getList`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPlanList error:", error);
    return { status: false, type: "danger", success: "Failed to fetch plans" };
  }
}

// 🔹 SAVE PLAN (ADD / EDIT)
export async function savePlan(
  plan_id,
  plan_name,
  plan_desc,
  plan_type,
  plan_price,
  plan_user_type,
  plan_duration,
  plan_review_limit,
  plan_camp_limit,
  plan_features,
  plan_status
) {
  try {
    const fd = new FormData();
    fd.append("plan_id", plan_id);
    fd.append("plan_name", plan_name);
    fd.append("plan_desc", plan_desc);
    fd.append("plan_type", plan_type);
    fd.append("plan_price", plan_price);
    fd.append("plan_user_type", plan_user_type);
    fd.append("plan_duration", plan_duration);
    fd.append("plan_review_limit", plan_review_limit);
    fd.append("plan_camp_limit", plan_camp_limit);
    fd.append("plan_features", plan_features);
    fd.append("plan_status", plan_status);

    const response = await axios.post(`${apiBaseUrl}planapis/save_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("savePlan error:", error);
    return { status: false, type: "danger", success: "Plan save failed" };
  }
}

// 🔹 DELETE PLAN
export async function deletePlan(plan_id) {
  try {
    const fd = new FormData();
    fd.append("plan_id", plan_id);

    const response = await axios.post(`${apiBaseUrl}planapis/delete_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deletePlan error:", error);
    return { status: false, type: "danger", success: "Plan delete failed" };
  }
}